module.exports = __webpack_public_path__ + "img/comedy.418551d3.svg";